import { getSyiSlice } from 'tradera/apps/syi/state/selectors/syi';

export const selectSyiShipping = (state) => getSyiSlice(state).shipping;

export const selectRecommendedWeight = (state) =>
    selectSyiShipping(state).recommendedWeight;

export const selectShippingRecommendations = (state) =>
    selectSyiShipping(state).shippingRecommendations;

export const selectShippingProviderIsAnOption = (providerId) => (state) =>
    selectSyiShipping(state)
        .shippingByWeight.flatMap((group) => group.products)
        .map((p) => p.providerId)
        .includes(providerId);
